export default __webpack_public_path__ + "static/hero-background-44f3d27d12f694b87a6d97f009ac7e42.png";